/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesExportJobs.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Export Job Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, December 16, 2019 - 01:51:12 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      12/16/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const ExportJobList = Loadable({
    loader: () => import('../containers/ExportJobs/ExportJobListContainer'),
    loading: Loading,
});

export const ExportJobForm = Loadable({
    loader: () => import('../containers/ExportJobs/ExportJobEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesExportJobs.js